<template>
  <IframeWrap :option="wrapSize" @loaded="handleLoad">
    <iframe
      ref="contentIframe"
      allowfullscreen="true"
      allow="camera;microphone;display-capture;clipboard-read;clipboard-write;"
      width="100%"
      frameborder="0"
      @load="handleLoad"
    ></iframe>
  </IframeWrap>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import IframeWrap from '@/components/iframe-wrap';
import { getAIPaintIframeUrl, IAIPaintConfig } from './util';
import { IIframewrap } from '@/components/iframe-wrap/type';

@Component({
  components: {
    IframeWrap
  }
})
export default class AIPaintIframe extends Vue {
  @Prop({ type: Object }) content!: Content & IAIPaintConfig & IIframewrap;

  isEnlarge = false;

  get url() {
    return getAIPaintIframeUrl(this.content);
  }

  get wrapSize() {
    return {
      width: this.content.width,
      height: this.content.height
    };
  }

  mounted() {
    const iframeEl = this.$refs.contentIframe as HTMLIFrameElement;
    iframeEl.src = this.url;
  }

  handleLoad() {
    this.$emit('loaded');
  }
}
</script>

<style scoped>
.wrapper {
  @apply w-full md:ml-12 md:mr-12 rounded-motif overflow-hidden shadow-lg;
  /* background-image: linear-gradient(to right, #6f41ef, #9f7ff7); */
  background-color: #6b6981;
  transition: 0.3s;
}
.enlarge {
  @apply fixed left-0 w-screen h-screen z-50;
  background-color: #6b6981;
  transition: 0.3s;
}
.iframe {
  @apply w-full h-80 overflow-hidden bg-white;
}
.iframe > iframe {
  @apply w-full h-full;
  /* 解决固宽后有黑边问题 */
  transform: scaleX(1.004) translateX(0.1%);
}

.setting {
  @apply flex items-center justify-center;
  flex: 0 0 2rem;
}
</style>
